<mat-tab-group [selectedIndex]="selectedIndex" (selectedTabChange)="onTabChange($event)">
  <mat-tab *ngFor="let land of bundeslandFilterService?.getSelectedBundesLaenderNamen()" [label]="land">
    <app-rbb-sonstiges-wetter [selectedBundesland]="selectedBundesland"
                              *ngIf="isAvailableForBundesland()"></app-rbb-sonstiges-wetter>
    <div class="wetter_content_container" *ngIf="!isAvailableForBundesland()">
      <h2>Es liegt kein Sonstiges Wetter für {{selectedBundesland}} vor</h2>
    </div>
  </mat-tab>
</mat-tab-group>
